<a href="javascript:void(0)" class="cursor-pointer">
    <button mat-icon-button
            (click)="handleClick()"
            matTooltip="Toggle Lendio's angular material theme"
            matTooltipPosition="below">
        <mat-icon color="accent">design_services</mat-icon>
    </button>
</a>
